export const GET_COORDS = 'GET_COORDS'
